const SCROLL_THRESHOLDS = [25, 50, 75, 100] as const;

type Threshold = (typeof SCROLL_THRESHOLDS)[number];

let teardown: (() => void) | null = null;
let seen: Set<Threshold> = new Set();

const isBrowser = () => typeof window !== 'undefined';

const getScrollPercent = () => {
  if (!isBrowser()) return 0;
  const { scrollTop, scrollHeight, clientHeight } =
    document.documentElement || document.body;
  if (scrollHeight <= clientHeight) return 100;
  return Math.round(((scrollTop + window.innerHeight) / scrollHeight) * 100);
};

export const startScrollDepthTracking = (path: string) => {
  if (!isBrowser()) return;
  // reset previous listeners
  teardown?.();
  seen = new Set();

  let ticking = false;

  const handle = () => {
    ticking = false;
    const percent = Math.min(100, getScrollPercent());
    SCROLL_THRESHOLDS.forEach((threshold) => {
      if (!seen.has(threshold) && percent >= threshold) {
        seen.add(threshold);
        // eslint-disable-next-line @typescript-eslint/no-var-requires
        const { track } = require('./index');
        track('scroll_depth', {
          percent: threshold,
          page_path: path,
          page_title: document.title,
        });
      }
    });
  };

  const onScroll = () => {
    if (!ticking) {
      ticking = true;
      requestAnimationFrame(handle);
    }
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  teardown = () => window.removeEventListener('scroll', onScroll);

  // in case user lands already at bottom (short pages)
  handle();
};

export const stopScrollDepthTracking = () => {
  teardown?.();
  teardown = null;
  seen.clear();
};
